// extracted by mini-css-extract-plugin
module.exports = {"container":"O-z","copy":"P-z","field":"Q-z","error":"R-z","disabled":"S-z","termsContainer":"T-z","termsHeading":"U-z","termsCopy":"V-z","submit":"W-z","srOnly":"X-z"};